import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';
import { APP_ZONES, NavigationOptionEnum } from '../workflow.type';
import { DummyRole } from '../workflow.v2.type';

export const exchangeNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map([
  [
    ButtonActionType.EXCHANGE_ACCEPT_QUOTE,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'conversion-successful',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.PAYMENT,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'conversion-failed',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
]);
